// guidanceWeeks.js — ตรรกะร่วมของ "สัปดาห์คาบแนะแนว"
// ใช้ทั้งหน้าติดตามคาบแนะแนวของงานแนะแนว (guidance/) และคอลัมน์ "แนะแนว"
// ในหน้าติดตามงานครูประจำชั้นของหัวหน้าวิชาการสามัญ (reports/) เพื่อให้สองหน้า
// อ่านตัวเลขชุดเดียวกันจาก guidanceModel.getGuidanceSummaryByRoom

export const WEEK_META = {
  checked: { label: "เช็คแล้ว", color: "#198754", bg: "success" },
  missed: { label: "ยังไม่เช็ค", color: "#dc3545", bg: "danger" },
  no_teaching: { label: "งดตามปฏิทิน", color: "#adb5bd", bg: "secondary" },
  upcoming: { label: "ยังไม่ถึงกำหนด", color: "transparent", bg: "light" },
};

// ข้อความ tooltip ของ 1 สัปดาห์ — บอกทั้งสถานะ เหตุผลจากปฏิทิน และหัวข้อที่เช็ค
export const weekTitle = (w) => {
  const parts = [`${w.date} — ${WEEK_META[w.status].label}`];
  if (w.reason) parts.push(`ปฏิทิน: ${w.reason}`);
  if (w.topic) parts.push(`หัวข้อ: ${w.topic}`);
  return parts.join(" · ");
};

// วันที่แบบสั้น DD/MM สำหรับชิปรายสัปดาห์
export const shortDate = (ymd) => `${ymd.slice(8, 10)}/${ymd.slice(5, 7)}`;

// สถานะการเข้าคาบแนะแนวของห้อง — ตัวหาร (expected) หักสัปดาห์ที่ปฏิทินปฏิบัติงาน
// ระบุว่างดการเรียนการสอน และสัปดาห์ที่ยังไม่ถึงกำหนดออกแล้ว
export const guidanceStatus = (g) => {
  if (!g) return "no_slot";
  if (g.expected_sessions == null) return g.total_checks > 0 ? "complete" : "none"; // ยังไม่มีกรอบเวลา
  if (g.expected_sessions === 0) return "na"; // ยังไม่ถึงกำหนด หรืองดทั้งภาคเรียน
  if (g.checked_sessions === 0) return "none";
  if (g.missed_sessions > 0) return "partial";
  return "complete";
};

// คำอธิบายสั้นใต้ badge — ตอบว่า "ทำไมไม่ครบ"
export const guidanceReason = (g) => {
  if (!g) return null;
  const parts = [];
  if (g.missed_sessions > 0) parts.push(`ขาด ${g.missed_sessions} สัปดาห์`);
  if (g.no_teaching_sessions > 0) parts.push(`งดตามปฏิทิน ${g.no_teaching_sessions}`);
  if (g.extra_sessions > 0) parts.push(`นอกตาราง ${g.extra_sessions}`);
  return parts.length ? parts.join(" · ") : null;
};
